/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignBoxTopRight = createReactComponent(
  "align-box-top-right",
  "IconAlignBoxTopRight",
  [
    [
      "path",
      {
        d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M11 9v-2", key: "svg-1" }],
    ["path", { d: "M14 13v-6", key: "svg-2" }],
    ["path", { d: "M17 11v-4", key: "svg-3" }]
  ]
);

export { IconAlignBoxTopRight as default };
//# sourceMappingURL=IconAlignBoxTopRight.js.map
